import React, { useContext } from 'react'
import {
  BasketTargetProductBanner,
  DISCOUNTS,
  formatImage,
  getDiscountType,
  getTargetProductId,
  isPromotionWithLoyalty,
  PRICE_PROMOTION_GROUPS_VALUES
} from 'chemistry'
import { getHighestPriorityPromo, getPromotionTexts, isPromoMultiTarget } from 'common/utils'
import { getDiscountData, text } from 'client/fragments/productDetailsFragmentInfo/components/DiscountPercentage'
import { TranslateContext } from 'client/common/translator'

export const TargetProductBanner = props => {
  const { productDetails } = props
  const t = useContext(TranslateContext)
  if (!productDetails?.potentialPromotions) return <div />

  const promotion = getHighestPriorityPromo(productDetails)
  if (
    PRICE_PROMOTION_GROUPS_VALUES.includes(promotion?.promotionGroup) ||
    promotion?.isTarget ||
    !Array.isArray(promotion?.targetProducts) ||
    promotion?.targetProducts?.length <= 0
  )
    return <div />

  const targetImage = promotion?.targetDetails?.image
  const translations = getTranslations(promotion, t)
  const isMultiTarget = isPromoMultiTarget(promotion)
  const { discount, isYellow } = getDiscountData(productDetails)
  const isLoyaltyProgram = isPromotionWithLoyalty({ group: promotion.promotionGroup })

  return (
    <BasketTargetProductBanner
      promotion={promotion}
      title={translations.title}
      targetImageLink={formatImage(targetImage, '80')}
      targetProductLink={translations.targetProductLink}
      linkText={translations.linkText}
      linkHref={translations.linkHref}
      linkTextSuffix={translations.linkTextSuffix}
      linkId='add-to-basket-check-promotion-page-link'
      text={text(discount, t)}
      texts={getPromotionTexts(t)}
      isMultiTarget={isMultiTarget}
      isYellow={isYellow}
      isLoyaltyProgram={isLoyaltyProgram}
    />
  )
}

function getTranslations(promotion, t) {
  const title = getTitle(promotion, t)
  const targetId = getTargetProductId(promotion)

  return {
    title,
    linkText: t('unequal_basket_promotion_link_title'),
    linkHref: t('unequal_pdp_discount_product_link', { id: targetId }),
    linkTextSuffix: getDescriptionSuffix(promotion, t),
    targetProductLink: t('unequal_pdp_discount_product_link', { id: targetId })
  }
}
function getDescriptionSuffix(promotion, t) {
  const isLoyaltyProgram = isPromotionWithLoyalty({ group: promotion.promotionGroup })
  let loyaltyText = ''
  if (isLoyaltyProgram) loyaltyText = ` ${t('met_praxis_plus')}`

  return t('unequal_basket_promotion_link_title_suffix', { loyaltyText })
}
function getTitle(promotion, t) {
  const discountType = getDiscountType(promotion)
  const { amount } = promotion

  // free discount
  if (discountType === DISCOUNTS.FREE) return t('unequal_basket_free_promotion_title')
  return t('unequal_basket_percentage_promotion_title', { amount })
}
